import { createContext, useContext } from 'react';

/**
 * Provided by <MapAtlasFrame>. Consumers (MapNode, CharacterFigurine) read this
 * to project a node's source-image coordinate into the frame's pixel space.
 *
 * Shape: { atlas, containerW, containerH, projectNode: (srcX, srcY, anchor?) => { x, y } }
 *
 * Default value's projectNode returns the origin so consumers rendered outside a
 * frame degrade gracefully instead of throwing.
 */
export const AtlasProjectionContext = createContext({
  atlas: null,
  containerW: 0,
  containerH: 0,
  projectNode: () => ({ x: 0, y: 0 }),
});

export function useAtlasProjection() {
  return useContext(AtlasProjectionContext);
}
